import { initContactForm } from './forms/initContactForm';

export const initForms = () => {
    initContactForm();
};
